
// this import will change, maybe the name too
import { MultistepForm, FormStep, FormFieldTextAddressInput } from "stentor-models";

export interface FormDataInputOption {
    /**
     * The type of option
     */
    type: "CONTACT_US" | "SCHEDULE_SERVICE" | "GET_QUOTE";
    /**
     * The label for the option
     */
    label?: string;

    header?: string;

    consent?: {
        require?: boolean;
        consentMessage?: string;
    }
}

export interface FormDataInput {
    /**
     * The name of the form, this has to match up with handler data CAPTURE_MAIN_FORM
     */
    name: string;
    /**
     * Only a one step submit with a thank you.
     */
    formOnly?: boolean;
    /**
     * Options for the form
     */
    options: FormDataInputOption[];
    /**
     * Optional details message to explain what the additional message is for.
     */
    detailsMessage?: string;
    /**
     * Optional thank you message to show after the form is submitted.  Opportunity to set expectations
     * as to when they will be contacted.
     */
    thankYouMessage?: string;
    /**
     * Optional logo to show on the thank you page
     */
    logoUrl?: string;
    // Reserving for future for address autocomplete settings
    latitude?: number;
    longitude?: number;
    radius?: number;
}

export function generateFormsData(input: FormDataInput): MultistepForm {

    const { name } = input;

    const detailMessage = input.detailsMessage || "Please provide us with more details about your request";

    const thankYouMessage = input.thankYouMessage || "Thank you for your request. We will get back to you as soon as possible.";

    const scheduleSettings = input.options.find(option => option.type === "SCHEDULE_SERVICE");

    // go through the options and add our chips
    const chips = input.options.map(option => {
        return {
            id: option.type.toLowerCase(),
            label: option.label || option.type.replace("_", " ")
        }
    });

    // First step is our contact information
    const contactStep: FormStep = {
        name: "contact_info",
        nextAction: "submit",
        fields: [
            {
                name: "full_name",
                label: "Name",
                type: "TEXT",
                mandatory: true
            },
            {
                format: "PHONE",
                name: "phone",
                label: "Phone",
                placeholder: "Your 10 digit phone number",
                type: "TEXT",
                mandatory: true
            },
            {
                mapsBaseUrl: "https://places.xapp.ai",
                format: "ADDRESS",
                name: "address",
                label: "Address",
                type: "TEXT",
                mandatory: false
            } as FormFieldTextAddressInput,

        ],
        title: "Contact Information"
    };

    if (!input.formOnly) {
        contactStep.fields.push({
            name: "help_type",
            title: "How can we help?",
            type: "CHIPS",
            items: chips,
            mandatory: true,
            radio: true
        });
    }

    // DETAIL STEP

    const detailsStep: FormStep = {
        name: "details_info",
        nextAction: "submit",
        fields: [
            {
                name: "message",
                label: detailMessage,
                rows: 6,
                type: "TEXT",
                multiline: true
            }
        ],
        title: "Tell us more"
    };

    // TIME STEP

    if (scheduleSettings) {

    }

    const timeStep: FormStep = {
        name: "time_request",
        condition: "!help_type.includes('contact_us')",
        nextAction: "submit",
        fields: [
            {
                name: "dateTime",
                title: "Preferred date",
                type: "DATE",
                mandatory: false
            },
            {
                "name": "preferred_time",
                "type": "CHIPS",
                "items": [
                    {
                        "id": "first_available",
                        "label": "First Available"
                    },
                    {
                        "id": "morning",
                        "label": "Morning"
                    },
                    {
                        "id": "afternoon",
                        "label": "Afternoon"
                    }
                ],
                "mandatory": true,
                "radio": true
            },
            {
                name: "time_request_note_card",
                // Not sure if this is actually real or not
                text: "We will call you to work out an exact time after we receive all your details. Alternatively you can can call us right now to see if there is earlier availability.",
                title: "Card",
                type: "CARD"
            }
        ]
    }

    // CONFIRMATION
    const confirmationStep: FormStep = {
        final: true,
        name: "confirmation",
        nextLabel: "Submit",
        crmSubmit: true,
        nextAction: "submit",
        fields: [
            {
                name: "confirmation_card0",
                variant: "h6",
                text: "#{help_type}",
                type: "CARD"
            },
            {
                name: "confirmation_card1",
                variant: "body1",
                condition: "!!dateTime && preferred_time.length > 0",
                style: {
                    "fontStyle": "italic"
                },
                text: "Arrival Preference",
                type: "CARD"
            },
            {
                "name": "confirmation_card12",
                "variant": "body1",
                "condition": "!!dateTime && preferred_time.length > 0",
                "text": "#{dateTime}, #{preferred_time}",
                "type": "CARD"
            },
            {
                "name": "confirmation_card15",
                "variant": "body1",
                "text": "#{address}\n#{phone}",
                "type": "CARD"
            },
            {
                "name": "confirmation_card2",
                "text": "Somebody will call you as soon as possible to finalize the time and collect final details.",
                "align": "left",
                "type": "CARD"
            },
            // make this a config
            /*
            {
                "name": "confirmation_card3",
                "type": "CARD",
                "text": "Estimates to replace heating and cooling systems are free of charge. Repair jobs include a diagnostic fee of $99*. Service agreement customers pay $0 diagnostic fee."
            },
            {
                "name": "confirmation_card4",
                "type": "CARD",
                "text": "(New customer diagnostic special: $59 for VA customers and $79 for DC/MD customers. $99 plumbing diagnostic is applied to repair work if performed same day.)"
            },
            {
                "name": "consent_approval",
                "type": "CHECK",
                "items": [
                    {
                        "id": "agreed",
                        "label": "I agree"
                    }
                ],
                "mandatory": true
            } */
        ]
    };


    // THANK YOU

    const thankYouStep: FormStep = {
        name: "thank_you",
        fields: [],
        "previousAction": "omit",
        "nextAction": "omit"
    };

    if (input.logoUrl) {
        thankYouStep.fields.push({
            name: "thank_you_image",
            type: "CARD",
            media: {
                alt: "Logo",
                imageUrl: input.logoUrl
            }
        })
    }

    thankYouStep.fields.push({
        name: "thank_you_text",
        type: "CARD",
        header: {
            title: "Thank You"
        },
        text: thankYouMessage,
    });

    const form: MultistepForm = {
        type: "FORM",
        name,
        header: [
            {
                step: "contact_info",
                label: "Contact"
            },
            {
                step: "details_info",
                label: "Details"
            },
            {
                step: "time_request",
                label: "Time"
            },
            {
                step: "confirmation",
                label: "Confirmation"
            },
            {
                step: "thank_you",
                label: "Thank You"
            }
        ],
        labelHeader: true,
        steps: [
            contactStep,
            detailsStep,
            timeStep,
            confirmationStep,
            thankYouStep
        ]
    }

    return form;

}